import "./style.scss";
import $ from "jquery";
import "jquery-modal";
import Router from "./util/Router";

import common from "./routes/common";
import home from "./routes/home";
import payment from "./routes/payment";
import blog from "./routes/blog";
import offlineQuestionnaire from "./routes/offlineQuestionnaire";
import pageTemplateRamadanPage from "./routes/home";
import deliveryPolicy from "./routes/policies";
import refundPolicy from "./routes/policies";
import termsConditions from "./routes/policies";
import joinUs from "./routes/joinUs";
import kuwaitPage from "./routes/kuwait";
import Functions from "./js/functions";
/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  /** All pages */
  common,
  /** Home page */
  home,
  /** Ramadan page */
  pageTemplateRamadanPage,
  /** Payment page */
  payment,
  /** Blog page */
  blog,
  /** Offline questionnaire page */
  offlineQuestionnaire,
  /** Policy pages */
  refundPolicy,
  deliveryPolicy,
  termsConditions,
  /** Join us pages */
  joinUs,
  /** Kuwait page */
  kuwaitPage

  /** About Us page, note the change from about-us to aboutUs. */
});

/** Load Events */
$(document).ready(() => routes.loadEvents());
Functions.maskInput();

$(".main-menu__mobile").on("click", () => {
  $(".main-menu").fadeIn();
});

$(".main-menu__close").on("click", () => {
  $(".main-menu").fadeOut();
});

// alert("work?");
setTimeout(() => $(".popup__container").modal(), 1000);

$(document).mouseup(function(e) {
  if (
    $(".main-menu").css("display") !== "none" &&
    document.documentElement.clientWidth < 992
  ) {
    let div = $(".main-menu__content");
    if (!div.is(e.target) && div.has(e.target).length === 0) {
      div.parent().fadeOut();
    }
  }
});
